import type { TranslationInterface } from '.';

export const CroatianLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Napišite poruku...',
  your_issue_has_been_resolved: 'Vaš problem je riješen!',
  new_conversation: 'Novi razgovor',
  welcome_screen_title: 'Dobrodošli u naš chat za podršku',
  welcome_screen_description:
    'Ovdje smo da pomognemo! Započnite razgovor i odgovorit ćemo vam što je prije moguće.',
  your_name_placeholder: 'Vaše ime',
  your_email_placeholder: 'Vaša e-mail adresa',
  start_chat_button: 'Razgovarajte s podrškom',
  start_chat_button_loading: 'Povezivanje...',
  i_need_more_help: 'Trebam dodatnu pomoć',
  this_was_helpful: 'Ovo je bilo korisno',
  optional: 'Neobavezno',
  no_conversations_yet: 'Još nema razgovora',
  back_to_conversations: 'Natrag na razgovore',
  closed_conversations: 'Zatvoreni razgovori',
  csat_title: 'Kakav je bio vaš razgovor?',
  csat_submitted_title: 'Ocijenili ste razgovor kao',
  csat_feedback_placeholder: 'Recite nam više... (neobavezno)',
  follow_up_placeholder: 'Nastavite…',
  companion_layout_label: 'Raspored',
  companion_layout_floating: 'Plutajući',
  companion_layout_sidebar: 'Bočna traka',
  companion_layout_fullscreen: 'Cijeli zaslon',
  companion_close: 'Zatvori',
  companion_history: 'Povijest razgovora',
  companion_expand_chat: 'Proširi razgovor',
  companion_sidebar_dock_label: 'Usidravanje',
  companion_sidebar_side_label: 'Strana',
  companion_sidebar_left: 'Lijevo',
  companion_sidebar_right: 'Desno',
  companion_resize_chat: 'Promijeni veličinu razgovora',
  scroll_to_bottom: 'Pomakni se na dno',
  thinking: 'Razmišljam…',
  running: 'Izvršava se…',
  steps: 'koraci',
  step_arguments: 'Argumenti',
  step_result: 'Rezultat',
  attach_files:
    'Priložite slike, videozapise, PDF-ove ili proračunske tablice (najveća veličina 25 MB)',
  mark_page_active:
    'Kliknite bilo što na stranici da biste to označili — Esc za odustajanje',
  mark_page: 'Označite nešto na stranici da biste pitali o tome',
  stop_response: 'Zaustavi odgovor',
  copy_reply: 'Kopiraj odgovor',
  mentions_empty: 'Nema rezultata',
  copied: 'Kopirano',
  send_message: 'Pošalji poruku',
  upload_failed: 'Prijenos nije uspio: {error}',
  remove_attachment: 'Ukloni privitak',
  json_no_items: 'Nema stavki',
  json_no_data: 'Nema podataka',
  json_no_chart_data: 'Nema podataka za grafikon',
  json_unsupported: 'Nije podržano: {type}',
  json_see_less: 'Prikaži manje',
  json_phone_agent: 'Telefonski agent',
  json_phone_agent_test: 'Testiraj putem weba',
  page_context_remove: 'Ukloni kontekst stranice',
  json_see_more: 'Prikaži još {count}',
  queued_label: '{count} Na čekanju',
  remove_queued_message: 'Ukloni poruku iz reda čekanja',
  send_queued_now: 'Pošalji poruke iz reda čekanja sada',
  turn_failed_message: 'Nešto je pošlo po zlu i odgovor nije stigao.',
  turn_failed_retry: 'Pokušaj ponovno',
  page_mark_hint: 'Kliknite nešto da biste to označili',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Okvir',
  page_mark_shape_circle: 'Krug',
  page_mark_shape_arrow: 'Strelica',
  page_mark_shape_bracket: 'Zagrada',
  page_mark_shape_underline: 'Podcrtavanje',
  page_mark_shape_highlight: 'Isticanje',
  page_mark_shape_strike_through: 'Precrtavanje',
  page_mark_shape_crossed_off: 'Križno precrtavanje',
  page_mark_shape_aria: 'Oblik oznake: {shape}',
  page_mark_note_placeholder: 'Dodajte bilješku… (Enter za prilaganje)',
  page_mark_attach: 'Priloži oznaku',
  page_mark_remove: 'Ukloni {label}',
  page_mark_region: 'Označeno područje',
  page_mark_default_message: 'Što je ovo?',
  file_rejected: 'Vrsta datoteke nije podržana ili je datoteka prevelika.',
  dictate: 'Diktiraj',
  stop_dictation: 'Zaustavi diktiranje',
  dictation_mic_blocked: 'Dopustite pristup mikrofonu za diktiranje',
  dictation_unavailable: 'Diktiranje trenutačno nije dostupno',
  questions_back: 'Natrag',
  questions_next: 'Dalje',
  questions_send: 'Pošalji',
  questions_type_answer: 'Napisat ću sam',
  questions_answer_placeholder: 'Napišite svoj odgovor…',
  close_conversation_title: 'Zatvori razgovor',
  close_conversation_description:
    'Jeste li sigurni da želite zatvoriti ovaj razgovor?',
  close_conversation_cancel: 'Ne',
  close_conversation_confirm: 'Da',
  dialog_close: 'Zatvori',
  zoom_in: 'Približi',
  zoom_out: 'Udalji',
  reset_zoom: 'Poništi zumiranje',
  support_chat_aria_label: 'Chat za podršku',
};
